/** 与现有充值网关的 UID 分区规则一致。 */
export function isPhilippineRechargeUser(uid) {
  const value = `${uid ?? ''}`.trim()
  return /^\d+$/.test(value) && BigInt(value) >= 50000000n
}

function dollarAmount(product) {
  // 菲区 cent 可能截断小数（$2.99 的 cent 为 "2"），不能优先用 cent 判断。
  const localized = product?.localPrice ?? product?.local_price
  const raw = localized != null && `${localized}`.trim() !== '' ? localized : product?.cent
  return `${raw ?? ''}`.trim().replace(/,/g, '').replace(/^(?:USD\s*|\$\s*)/i, '')
}

export function coinProductPrice(product) {
  const amount = dollarAmount(product)
  return /^\d+(?:\.\d+)?$/.test(amount) ? Number(amount) : NaN
}

export function filterCoinProducts(products, philippine) {
  return (Array.isArray(products) ? products : []).filter(product => {
    if (philippine) {
      const price = coinProductPrice(product)
      return price > 0 && Number.isFinite(price)
        && /^\d+(?:\.0+)?$/.test(dollarAmount(product)) && Number(product.coin) > 0
    }
    // 其他地区沿用原来的 $20 起充规则。
    const price = product.cent ? Number.parseFloat(product.cent) : Number(product.coin) / 50
    return price >= 20
  })
}

export function buildPhilippineCoinOrder(product, uid, returnUrl) {
  const payType = `${product?.supportedPayType ?? ''}`.trim().toUpperCase()
  if (!isPhilippineRechargeUser(uid) || !product?.id || !payType
    || !filterCoinProducts([product], true).length) {
    throw new Error('Invalid coin product or account')
  }
  return {
    product_id: product.id,
    pay_item_type: payType,
    user_id: uid,
    v2: true,
    extra: JSON.stringify({ front_callback_url: returnUrl, return_url: returnUrl }),
  }
}

function normalizeCoinPaymentUrl(value) {
  if (typeof value !== 'string') return ''
  let url = value.trim()
    .replace(/\\u([\da-f]{4})/gi, (_, code) => String.fromCharCode(parseInt(code, 16)))
    .replace(/\\\//g, '/')
    .replace(/&(?:amp|#0*38|#x0*26);/gi, '&')

  // 仅解开整条地址外层的编码。已是 HTTP(S) 地址时，保留查询参数里的
  // %26、%2B、%3D 等编码，避免改变支付 token 或签名。
  for (let depth = 0; depth < 3 && !/^https?:\/\//i.test(url); depth++) {
    try {
      const decoded = decodeURIComponent(url)
      if (decoded === url) break
      url = decoded
    } catch {
      return ''
    }
  }
  if (!/^https?:\/\//i.test(url)) return ''
  try {
    return new URL(url).href
  } catch {
    return ''
  }
}

/** 仅供菲区 Coin 下单使用，优先读取 payExtra 中的支付跳转地址。 */
export function coinPaymentUrl(value, depth = 0) {
  if (!value || depth > 8) return ''
  if (typeof value === 'string') {
    try { return coinPaymentUrl(JSON.parse(value), depth + 1) } catch { return '' }
  }
  if (typeof value !== 'object') return ''
  for (const key of ['paymentRedirectUrl', 'payment_redirect_url']) {
    const url = normalizeCoinPaymentUrl(value[key])
    if (url) return url
  }
  for (const key of ['payInfo', 'pay_info', 'payInfoExtra', 'pay_info_extra', 'payExtra', 'pay_extra', 'bizContent', 'data']) {
    const url = coinPaymentUrl(value[key], depth + 1)
    if (url) return url
  }
  for (const key of ['redirectUrl', 'redirect_url', 'paymentUrl', 'payment_url', 'payUrl', 'pay_url', 'payLink', 'checkoutUrl', 'checkout_url', 'url']) {
    const url = normalizeCoinPaymentUrl(value[key])
    if (url) return url
  }
  return ''
}
